import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const validateInvitationGenerateApi = createAsyncThunk(
    'invitation/generate/validate',
    async (token, { rejectWithValue }) => {
        try {
            const response = await fetch(
                `${ROOT_URL}/co-users/invitation-generate/validate/${token}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            );
            const result = await response.json();
            return result;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    response: null,
    error: null,
};

const validateInvitationGenerateSlice = createSlice({
    name: 'validateInvitationGenerate',
    initialState,
    reducers: {
        resetValidationGenerateState: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.response = null;
            state.error = null;
        },
    },
    extraReducers: {
        [validateInvitationGenerateApi.pending]: (state) => ({
            ...state,
            isLoading: true,
            error: null,
        }),
        [validateInvitationGenerateApi.fulfilled]: (state, action) => ({
            ...state,
            isLoading: false,
            isSuccess: true,
            isError: false,
            response: action.payload,
        }),
        [validateInvitationGenerateApi.rejected]: (state, action) => ({
            ...state,
            isLoading: false,
            isSuccess: false,
            isError: true,
            error: action.payload,
        }),
    },
});

export const { resetValidationGenerateState } = validateInvitationGenerateSlice.actions;
export default validateInvitationGenerateSlice;
